import { ModelCommon, UserAttributeDefs, ValidBusinessObject } from '@iotv/datamodel-core'

const typeName = 'Waternetwork'

export type WaternetworkProps = {
  id: string
  name: string
  type: string
  purpose: string
  pk: string
  sk: string
  networktype: string
  linkedEntity?: ValidBusinessObject[]
  position?: {
    edges: {
      source: string
      target: string
      id: string
      sourceHandle?: string | null // Allow null
      targetHandle?: string | null // Allow null
    }[]
    nodes: {
      id: string
      data: { [key: string]: any }
      position: { x: number; y: number }
      width?: number | null // Allow null in addition to undefined
      height?: number | null // Allow null in addition to undefined
      dragging?: boolean
    }[]
    viewport: {
      x: number
      y: number
      zoom: number
    } // Explicitly define the viewport type
  }
}

export class Waternetwork extends ModelCommon implements WaternetworkProps {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
    this.purpose = ob.purpose ?? ''
    this.networktype = ob.networktype ?? ''
    this.name = ob.name ?? ''
  }
  name: string
  linkedEntity?: ValidBusinessObject[] | undefined
  position?:
    | {
        edges: {
          source: string
          target: string
          id: string
          sourceHandle?: string | null // Allow null
          targetHandle?: string | null // Allow null
        }[]
        nodes: {
          id: string
          data: { [key: string]: any }
          position: { x: number; y: number }
          width?: number | null // Allow null in addition to undefined
          height?: number | null // Allow null in addition to undefined
          dragging?: boolean
        }[]
        viewport: {
          x: number
          y: number
          zoom: number
        } // Explicitly define the viewport type
      }
    | undefined

  purpose: string
  networktype: string

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of WaterNetwork',
      },
      purpose: {
        type: 'String',
        editable: true,
        label: 'Purpose',
        name: 'purpose',
        description: 'Used for',
      },
      networktype: {
        type: 'String',
        editable: true,
        label: 'Network type',
        name: 'Networktype',
        description: 'Used for',
      },
    }
  }
}
